<template>
    <!-- 临时储物柜 -->
    <el-form v-loading="loading">
        <div class="temporary-locker-components">
            <div class="temporary-locker-search flex items-center">
                <el-input
                    @keyup.enter.native="fetchData(1)"
                    class="temporary-locker-search-input"
                    v-model="form.keyword"
                    :placeholder="$t('Common.client_tip')">
                </el-input>
                <div class="pl-6">
                    <el-button
                        type="primary"
                        @click="fetchData(1)">
                        {{ $t('Common.search') }}
                    </el-button>
                    <el-button @click="resetForm">{{ $t('Common.clear') }}</el-button>
                </div>
            </div>

            <div class="container-content">
                <div class="content-store">
                    <div class="content-title flex justify-between">
                        <div class="flex items-center">{{ $t('Reception.Fourth.area') }}</div>
                        <div class="flex">
                            <el-tooltip effect="dark" :content="$t('tooltip.add')" placement="bottom">
                                <div
                                    class="iconfont add icon-fitness-tianjiawenjian"
                                    @click="handleArea('add')"></div>
                            </el-tooltip>
                            <el-tooltip effect="dark" :content="$t('tooltip.edit')" placement="bottom">
                                <div
                                    class="iconfont edit
                                    icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy"
                                    @click="handleArea('edit')"
                                ></div>
                            </el-tooltip>
                            <el-tooltip effect="dark" :content="$t('tooltip.delete')" placement="bottom">
                                <div
                                    class="iconfont delete icon-fitness-shanchu"
                                    @click="handleDeleteArea"
                                ></div>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="content-info">
                        <div v-for="(i, index) in data" :key="index">
                            <div>{{ i.storeName }}</div>
                            <ul class="locker-ul"
                                v-for="(item, iindex) in i.areas"
                                :key="`child-${iindex}`">
                                <li class="locker-li"
                                    @click="changeList(item.id)"
                                    :class="clickIndex == item.id ? 'clicked' : ''">
                                    {{ item.name }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="content-select">
                    <div class="content-title flex justify-between">
                        <div class="flex items-center">{{ $t('Reception.Fourth.small_title') }}</div>
                        <div class="flex">
                            <el-tooltip effect="dark" :content="$t('tooltip.add')" placement="bottom">
                                <div class="iconfont add icon-fitness-tianjiawenjian"
                                    @click="handleAdd"></div>
                            </el-tooltip>
                            <el-tooltip effect="dark" :content="$t('tooltip.edit')" placement="bottom">
                                <div
                                    class="iconfont edit
                                    icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy"
                                    @click="handleEdit"
                                ></div>
                            </el-tooltip>
                            <el-tooltip effect="dark" :content="$t('tooltip.delete')" placement="bottom">
                                <div class="iconfont delete icon-fitness-shanchu"
                                    @click="handleDelete"></div>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="content-info">
                        <el-table ref="multipleTable"
                            :data="tableData"
                            tooltip-effect="dark"
                            style="width: 100%;margin-bottom: 15px;"
                            border
                            @row-click="clickRow"
                            @selection-change="handleSelectionChange">
                            <el-table-column type="selection" />
                            <el-table-column
                                prop="storeAreaName"
                                :label="$t('Reception.Fourth.area1')" />
                            <el-table-column prop="initial" :label="$t('Reception.Fourth.letter')" />
                            <el-table-column prop="lockerNum" :label="$t('Reception.Fourth.number')" />
                            <el-table-column prop="status" :label="$t('Reception.Fourth.status')">
                            </el-table-column>
                            <el-table-column :label="$t('Reception.Fourth.name')" >
                                <template slot-scope="{row}">
                                    <span
                                        class="clicked cursor-pointer"
                                        @click="handleUser(row.clientId)">
                                        {{ row.clientName }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="clientPhone" :label="$t('Reception.Fourth.phone')" />
                        </el-table>
                        <el-pagination
                                v-if="tableData && tableData.length"
                                class="text-right"
                                @current-change="fetchData"
                                :current-page.sync="form.page"
                                :page-size="pagination.size"
                                layout="total, prev, pager, next, jumper"
                                :total="pagination.total">
                        </el-pagination>
                    </div>
                </div>
            </div>

            <!-- 添加区域 -->
            <add-area ref="area" @fetchLocker="fetchLocker" />
            <!-- 添加临时储物柜 -->
            <add-cabinet ref="cabinet" @fetchData="fetchData" @fetchLocker="fetchLocker"/>
            <!-- 编辑临时储物柜 -->
            <edit-cabinet ref="edit" @fetchData="fetchData"/>
        </div>
    </el-form>
</template>

<script>
import handleUser from '@/mixins/handleUser.js';
import AddArea from '@/components/Dialog/Reception/AddArea';
import AddCabinet from '@/components/Dialog/Reception/AddCabinet';
import EditCabinet from '@/components/Dialog/Reception/EditCabinet';

export default {
    name: 'temporary-locker',
    components: {
        AddArea,
        AddCabinet,
        EditCabinet,
    },
    mixins: [handleUser],
    data() {
        return {
            pagination: {
                size: 10,
                total: 0,
            },
            form: {
                keyword: '',
                page: 1,
                areaId: null,
            },
            data: [],
            tableData: [],
            clickIndex: null,
            deleteIds: [],
            loading: false,
        };
    },
    methods: {
        permission () {
            if (this.$$filterPermission('前台-钥匙牌管理-区域及钥匙牌生成和删除 区域编辑')) return true;
            else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
                return false;
            }
        },
        permissionStatus() {
            if (this.$$filterPermission('前台-钥匙牌管理-钥匙牌状态变更')) return true;
            else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
                return false;
            }
        },
        fetchLocker() {
            API.get('area/temporary').then(res => {
                this.data = res;
                // 赋值
                this.clickIndex = this.clickIndex ? this.clickIndex : res[0].areas[0].id;
                this.form.areaId = this.clickIndex;
                this.fetchData(1);
            });
        },
        // 获取柜子信息
        fetchData(page = null) {
            this.loading = true;
            if (page) this.form.page = page;
            API.get('temporary-locker/pages', {
                params: this.form,
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
            }).finally(() => {
                this.loading = false;
            });
        },
        handleArea(type) {
            const itemObj = {
                storeId: null,
                name: null,
                id: null,
            };
            this.data.forEach(el => {
                el.areas.map(item => {
                    if (item.id === this.clickIndex) {
                        if (type === 'edit') {
                            itemObj.name = item.name;
                            itemObj.id = item.id;
                        }
                        itemObj.storeId = el.storeId;
                    }
                    return itemObj;
                });
            });
            // 传入门店id,当前区域名
            if (this.permission()) this.$refs.area.open(itemObj.storeId, itemObj.name, itemObj.id, type);
        },
        handleDeleteArea() {
            const id = this.clickIndex;
            $ele.$confirm(this.$t('Reception.Fifth.dialog_delete'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                if (this.permission()) {
                    API.delete(`area/${id}`).then(() => {
                        // 删除接口
                        $ele.$message.success(this.$t('Message.delete_success'));
                        this.clickIndex = null;
                        this.fetchLocker();
                    });
                }
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
        handleAdd() {
            const itemObj = {
                storeId: null,
            };
            this.data.forEach(el => {
                el.areas.map(item => {
                    if (item.id === this.clickIndex) {
                        itemObj.storeId = el.storeId;
                    }
                    return itemObj;
                });
            });
            if (this.permission()) this.$refs.cabinet.open(1,itemObj.storeId);
        },
        handleEdit() {
            if (!this.deleteIds.length || this.deleteIds.length !== 1) $ele.$message.info(this.$t('Message.tip_one'));
            else if (this.permission() || this.permissionStatus()) {
                this.$refs.edit.open(this.deleteIds[0]);
            }
        },
        handleDelete() {
            if (!this.deleteIds.length) return $ele.$message(this.$t('Message.tip_one'));
            $ele.$confirm(this.$t('Reception.Fourth.delete_confirm'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                if (this.permissionStatus()) {
                    // 删除接口
                    const ids = this.deleteIds.join(',');
                    API.delete(`temporary-locker/${ids}`).then(() => {
                        $ele.$message.success(this.$t('Message.delete_success'));
                        this.fetchLocker();
                    });
                }
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
        handleSelectionChange(val) {
            if (val.length) {
                this.deleteIds = val.map(el => el.id);
            } else {
                this.deleteIds = [];
            }
        },
        clickRow(row) {
            this.$refs.multipleTable.toggleRowSelection(row);
        },
        // 改变区域
        changeList(id) {
            this.clickIndex = id;
            this.form.areaId = this.clickIndex;
            // 接口获取数据
            this.fetchData(1);
        },
        resetForm() {
            this.form.keyword = null;
            this.fetchData(1);
        },
    },
    created() {
        this.fetchLocker();
    },
};
</script>

<style lang="scss">
.temporary-locker-components {
    .temporary-locker-search {
        width: 100%;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 15px;
        margin-bottom: 15px;
    }
    .temporary-locker-search-input {
        width: 400px;
    }
    .container-content {
        font-size: 14px;
        color: #666;
    }
    .content-store,
    .content-select {
        width: 25%;
        margin-right: 1%;
        border: 1px solid #e6e6e6;
        display: inline-block;
        vertical-align: text-top;
        display: inline-block;
        vertical-align: top;
    }
    .content-select {
        width: 74%;
        margin-right: 0;
    }
    .content-title {
        font-size: 13px;
        background: #fafafa;
        padding: 18px 20px;
        border-bottom: 1px solid #e6e6e6;
    }
    .add,
    .delete,
    .edit {
        color: #697a8e;
    }
    .add {
        font-size: 18px;
    }
    .edit {
        margin: 0 12px;
    }
    .content-info {
        color: rgb(102, 102, 102);
        padding: 15px;
        font-size: 13px;
    }
    ul.locker-ul {
        padding-left: 15px;
    }
    li.locker-li {
        list-style: none;
        list-style-position: inside;
        margin: 15px 0;
        cursor: pointer;
    }
    .clicked {
        color: #05abef;
    }
}
.el-pager li.active {
    margin: 0 !important;
}
</style>
